import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import SideBarMenu from "../Component/SideBarMenu";
import { Button } from "react-bootstrap";
import TopHeader from "../Component/TopHeader";
import SpotsFilters from "../Component/Filters/SpotsFilters";

import { toggleRightSidebarAction } from "../../Store/Actions/AuthActions";

import {
  deleteAdminSpotsListAction,
  getAdminSpotsListAction,
} from "../../Store/Actions/SpotsActions";
import { display, formatSpotPrice, showToast } from "../../utils/helper";
import { trackEvent } from "../../utils/analytics";
import DetailsRightSidebar from "../Component/DetailsRightSidebar";
import AddSpotModal from "../Component/Models/AddSpotModal";
import KebabMenu from "../Component/KebabMenu";
import ConfirmModal from "../Component/Models/ConfirmModal";
import FilterPopover from "../Component/FilterPopover";
import StatusDot from "../Component/StatusDot";
import Pagination from "../Component/Pagination";

const SpotsList = () => {
  const dispatch = useDispatch();
  const menuState = useSelector((state) => state.auth.isMenuOpen);
  // const rightSidebar = useSelector((state) => state.auth.isRightSidebarOpen);
  const { adminSpots } = useSelector((state) => state.spots);

  const [loading, setLoading] = useState(false);
  const [delLoading, setDelLoading] = useState({});
  const [filters, setFilters] = useState({});
  const [spotModal, setSpotModal] = useState({ show: false, spot: null });
  const [confirmDel, setConfirmDel] = useState({ show: false, item: null });
  const [showSidebar, toggleShowRightSidebar] = useState({
    show: false,
    item: {},
  });
  const [pagging, setPagging] = useState({
    totalItems: "",
    itemsPerPage: "",
    currentPage: "",
    totalPages: "",
    nextPage: 1,
    limit: 15,
  });

  const stripEmpty = (obj) =>
    Object.fromEntries(
      Object.entries(obj).filter(([, v]) => v !== "" && v !== null && v !== undefined),
    );

  const askDeleteSpot = (item) => {
    if (delLoading[item.id]) return;
    setConfirmDel({ show: true, item });
  };

  const performDeleteSpot = () => {
    const item = confirmDel.item;
    if (!item || delLoading[item.id]) return;

    setDelLoading({ ...delLoading, [item.id]: true });

    deleteAdminSpotsListAction({ id: item.id }, dispatch)
      .then((res) => {
        setDelLoading({ ...delLoading, [item.id]: false });
        setConfirmDel({ show: false, item: null });
        if (res && res.type === "success") {
          trackEvent("web_spot_deleted", {
            spot_id: item.id,
            role: "admin",
          });
        }
        showToast(res.message);
      })
      .catch((err) => {
        setDelLoading({ ...delLoading, [item.id]: false });
        setConfirmDel({ show: false, item: null });
        showToast(err.message);
      });
  };

  const getSpotsList = (page = 1, overrideFilters) => {
    if (!loading) {
      setLoading(true);

      const listParams = {
        page,
        limit: pagging.limit,
        ...stripEmpty(overrideFilters || filters),
      };

      getAdminSpotsListAction(listParams, dispatch)
        .then((res) => {
          setLoading(false);
          if (res.type === "success") {
            setPagging({
              ...pagging,
              ...res.pagination,
            });
          }
        })
        .catch((err) => {
          setLoading(false);

          showToast("error", err.message);
        });
    }
  };

  const renderPagging = () => (
    <Pagination
      currentPage={pagging.currentPage || 1}
      totalPages={pagging.totalPages || 1}
      totalItems={pagging.totalItems}
      onPageChange={(p) => getSpotsList(p)}
    />
  );

  useEffect(() => {
    if (adminSpots.length === 0) {
      getSpotsList();
    }
  }, []);

  return (
    <>
      <div className={`app-wrapper ${menuState ? "open" : ""}`}>
        <SideBarMenu />

        <div className="content-wrapper">
          <TopHeader title={"Spots"} />

          <div className="content">
            <div className="list-toolbar">
              <div className="list-toolbar-spacer" />

              <FilterPopover
                count={
                  Object.values(filters).filter(
                    (v) => v !== "" && v !== null && v !== undefined,
                  ).length
                }
              >
                {(close) => (
                  <SpotsFilters
                    initial={filters}
                    onApply={(values) => {
                      setFilters(values);
                      getSpotsList(1, values);
                      close();
                    }}
                  />
                )}
              </FilterPopover>

              <Button
                variant=""
                className="list-add-btn"
                onClick={() => setSpotModal({ show: true, spot: null })}
              >
                <span>
                  <i className="fas fa-plus me-1" />
                  Add Spot
                </span>
              </Button>
            </div>

                <div className="data-listing">
                  <table className="table">
                    <thead className="thead-light">
                      <tr>
                        <th width="13%">Name</th>
                        <th width="25%">Address</th>
                        <th width="10%" className="text-center">
                          Price / Hour
                        </th>
                        <th width="6%" className="text-center">
                          EV
                        </th>
                        <th width="10%">Status</th>
                        <th width="6%" className="text-center">
                          Actions
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {adminSpots.length > 0 &&
                        adminSpots.map((item) => (
                          <tr key={`spot-${item.id}`}>
                            <td>{display(item.name)}</td>
                            <td>{display(item.address)}</td>
                            <td className="text-center">
                              {formatSpotPrice(item)}
                            </td>
                            <td className="text-center">
                              {item.hasEvCharger ? (
                                <i
                                  className="fas fa-bolt text-success"
                                  title="EV charger available"
                                />
                              ) : (
                                "—"
                              )}
                            </td>
                            <td>
                              <StatusDot status={item.status} kind="spot" />
                            </td>
                            <td className="text-center">
                              <KebabMenu
                                items={[
                                  {
                                    label: "View",
                                    icon: "fas fa-eye",
                                    onClick: () => {
                                      toggleShowRightSidebar({
                                        show: true,
                                        item,
                                      });
                                      toggleRightSidebarAction(true, dispatch);
                                    },
                                  },
                                  {
                                    label: "Edit",
                                    icon: "fas fa-pen",
                                    onClick: () =>
                                      setSpotModal({ show: true, spot: item }),
                                  },
                                  {
                                    label: delLoading[item.id]
                                      ? "Deleting…"
                                      : "Delete",
                                    icon: "fas fa-trash",
                                    danger: true,
                                    disabled: !!delLoading[item.id],
                                    onClick: () => askDeleteSpot(item),
                                  },
                                ]}
                              />
                            </td>
                          </tr>
                        ))}

                      {adminSpots.length === 0 && (
                        <tr>
                          <td colSpan="7">
                            <p className="text-center">No Spots Available.</p>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
                {renderPagging()}
          </div>
        </div>

        {showSidebar.show && (
          <DetailsRightSidebar
            item={showSidebar.item}
            closeSidebar={() => {
              toggleShowRightSidebar({ show: false, item: {} });
            }}
          />
        )}

        {spotModal.show && (
          <AddSpotModal
            show={spotModal.show}
            spot={spotModal.spot}
            onClose={() => setSpotModal({ show: false, spot: null })}
            onSuccess={() => {
              setSpotModal({ show: false, spot: null });
              getSpotsList(pagging.currentPage || 1);
            }}
          />
        )}

        <ConfirmModal
          show={confirmDel.show}
          title="Delete Spot"
          message={
            confirmDel.item
              ? `Are you sure want to delete "${confirmDel.item.name}"?`
              : "Are you sure want to delete it?"
          }
          busy={confirmDel.item ? !!delLoading[confirmDel.item.id] : false}
          onClose={() => setConfirmDel({ show: false, item: null })}
          onConfirm={performDeleteSpot}
        />
      </div>
    </>
  );
};

export default SpotsList;
